function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "16.754%",
  y1: "73.235%",
  x2: "124.892%",
  y2: "-2.375%",
  id: "icon-device--tablet_svg__a"
}, React.createElement("stop", {
  stopColor: "#51575D",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#AEB7BD",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "33.457%",
  y1: "102.746%",
  x2: "108.205%",
  y2: "28.247%",
  id: "icon-device--tablet_svg__b"
}, React.createElement("stop", {
  stopColor: "#AEB7BD",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#DBE0E4",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "-69.666%",
  y1: "137.681%",
  x2: "35.151%",
  y2: "27.313%",
  id: "icon-device--tablet_svg__c"
}, React.createElement("stop", {
  stopColor: "#AEB7BD",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#DBE0E4",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "-45.5%",
  y1: "145%",
  x2: "88.5%",
  y2: "11%",
  id: "icon-device--tablet_svg__d"
}, React.createElement("stop", {
  stopColor: "#AEB7BD",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#DBE0E4",
  offset: "100%"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(21.867 10)",
  fillRule: "nonzero",
  fill: "none"
}, React.createElement("path", {
  d: "M4.865 0A4.85 4.85 0 000 4.865v78.943a4.868 4.868 0 004.865 4.866H57.08c2.7 0 4.895-2.196 4.895-4.866V4.865c0-2.7-2.196-4.865-4.895-4.865H4.865z",
  fill: "url(#icon-device--tablet_svg__a)"
}), React.createElement("path", {
  d: "M2.967 61.974v14.24c0 .415.326.741.741.741h54.557a.754.754 0 00.742-.741V20.767L2.967 61.974z",
  fill: "url(#icon-device--tablet_svg__b)"
}), React.createElement("path", {
  d: "M3.708 11.718a.734.734 0 00-.741.742v52.48l56.04-41.207V12.46a.754.754 0 00-.742-.742H3.708z",
  fill: "url(#icon-device--tablet_svg__c)"
}), React.createElement("circle", {
  fill: "url(#icon-device--tablet_svg__d)",
  cx: 31.002,
  cy: 82.74,
  r: 2.967
}));

var SvgIconDeviceTablet = function SvgIconDeviceTablet(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 108 108",
    width: "1em",
    height: "1em",
    focusable: false
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/icon-device--tablet.29d73e50.svg";
export { SvgIconDeviceTablet as ReactComponent };